import userInfo from 'hub-http/userInfo';
import Raven from 'raven-js';
import { useEffect, useState } from 'react';
import UserInfoContext from '../contexts/UserInfoContext';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UserInfoProvider({
  children
}) {
  const [userInfoData, setUserInfoData] = useState(null);
  useEffect(() => {
    userInfo().then(data => {
      setUserInfoData(data);
    }).catch(error => {
      Raven.captureException(error, {
        fingerprint: ['Error loading the userInfo in the collaboration sidebar']
      });
    });
  }, []);
  return /*#__PURE__*/_jsx(UserInfoContext.Provider, {
    value: userInfoData,
    children: children
  });
}